"use strict";
define(
'stores/rsvp-summaries',[
	"jquery",
	"underscore",
	"stores/store",
	"actions/rsvps",
	"constants/actiontypes"
],
function ($, _, StoreBase, Action, Constants)
{
	Store.prototype = new StoreBase();
	Store.constructor = Store;

	var PAGE_SIZE = 10;

	function Store (params)
	{
		// Call parent constructor
		StoreBase.call(this, params);

		this.registerDispatchListener(function (action) {
			switch(action.actionType) {
				case Constants.ADD_RSVP_SUMMARY:
					if(Array.isArray(action.data)) {
						_.each(action.data, function (data, index, list) {
							this.addRSVP(data);
						}, this);
					}
					else {
						this.addRSVP(action.data);
					}
					this.event.emit("change");
					break;
				case Constants.REFRESH_RSVP_SUMMARY:
					this.updateRSVP(action.data);
					this.event.emit("change");
					break;
			}
		}.bind(this));

		this.action = new Action();
		this.rsvps = {};
	}

	Store.prototype.addRSVP = function(data) {
		this.rsvps[data.guid] = data;
	}

	Store.prototype.updateRSVP = function(data) {
		this.rsvps[data.guid] = data;
	}

	Store.prototype.get = function(guid) {
		var ret = this.rsvps[guid];
		return ret;
	}

	Store.prototype.getAll = function(page, filterOptions, sortOptions) {
		// Gonna add filter and sort options
		var ret = _.map(this.rsvps);
		ret = ret.slice(page * PAGE_SIZE, (page+1) * PAGE_SIZE);

		return ret;
	}

	Store.prototype.getMaxPage = function() {
		var length = Object.keys(this.rsvps).length;
		return Math.floor((length-1) / PAGE_SIZE);
	}

	return Store;
});

